// AddCategoryModalForm.js
import React, { useState } from "react";
import axios from "axios";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

function AddModal({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    title: "",
    status: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [message, setMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { title, status } = formData;


    if (!title || status === "" || !imageFile) {
      setMessage("Please fill in all fields and upload an image.");
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }


    if (status === "0") {
      setMessage("Error: Banner status must be 1 (Active). You cannot set it to Inactive.");
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      const data = new FormData();
      data.append("title", title);
      data.append("status", status);
      data.append("image", imageFile);

      const token = localStorage.getItem("access_token");

      if (!token) {
        setMessage("Access token not found. Please log in again.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/add-banner`,
        data,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === false) {
        setMessage(response.data.message);
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      setMessage("Banner added successfully!");
      setFormData({ title: "", status: "" });
      setSnackbarType("success");
      setSnackbarOpen(true);
      setImageFile(null);

      if (onSuccess) {
        onSuccess();
      }

      setTimeout(() => {
        setMessage("");
        setSnackbarOpen(false);
        onClose();
      }, 1000);
    } catch (error) {
      console.error("Error adding banner:", error);
      if (error.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage("Failed to add banner. Please try again.");
      }
      setSnackbarType("error");
      setSnackbarOpen(true);
    }
  };
  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };
  return (
    <MDBox component="form" onSubmit={handleSubmit} p={3}>
      <div
        onClick={onClose}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          cursor: "pointer",
          fontSize: "20px",
          fontWeight: "bold",
          color: "#999",
        }}
        title="Close"
      >
        &times;
      </div>
      <MDTypography variant="h5" fontWeight="medium" mb={3}>
        Add Banner
      </MDTypography>

      <MDBox mb={2}>
        <MDInput
          label="Title"
          name="title"
          fullWidth
          value={formData.title}
          onChange={handleChange}
        />
      </MDBox>

      <MDBox mb={2}>
        <MDTypography variant="button" fontWeight="regular" display="block" mb={1}>
          Upload Image
        </MDTypography>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{
            display: "block",
            width: "100%",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "#fff",
          }}
        />
      </MDBox>

      <MDBox mb={2}>
        <MDTypography variant="button" fontWeight="regular" display="block" mb={1}>
          Status
        </MDTypography>
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          style={{
            width: "100%",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "#fff",
          }}
        >
          <option value="">Select status</option>
          <option value="1"> Active</option>
          <option value="0"> Inactive</option>
        </select>
      </MDBox>
      <MDBox mt={4} mb={1}>
        <MDButton variant="gradient" color="info" type="submit" fullWidth>
          Add Banner
        </MDButton>
      </MDBox>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarType}
          sx={{ width: "100%" }}
        >
          {message}
        </MuiAlert>
      </Snackbar>
    </MDBox>
  );
}

export default AddModal;
